import { render, staticRenderFns } from "./BaseHLSVideoPlayer.vue?vue&type=template&id=e84666fe&scoped=true&"
import script from "./BaseHLSVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./BaseHLSVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BaseHLSVideoPlayer.vue?vue&type=style&index=0&id=e84666fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84666fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e84666fe')) {
      api.createRecord('e84666fe', component.options)
    } else {
      api.reload('e84666fe', component.options)
    }
    module.hot.accept("./BaseHLSVideoPlayer.vue?vue&type=template&id=e84666fe&scoped=true&", function () {
      api.rerender('e84666fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseHLSVideoPlayer.vue"
export default component.exports